const SkeletonBlock = ({ className = '' }) => (
    <div className={`animate-pulse bg-[#dcdad3] rounded ${className}`} />
);

export default SkeletonBlock;
